<template>
  <Layout>
    <PageHeader :items="items" :title="title"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_length"></div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_filter text-md-end">
                  <b-button v-if="user_permissions.add_dental" v-b-modal.dental-modal variant="primary"><i class="fa fa-plus"></i> New Service
                  </b-button>
                  <!--                  ADDING NEW SERVICE MODAL-->
                  <b-modal id="dental-modal" centered ref="modal" hide-footer title="Add New Service"
                           @hidden="resetAddModal">
                    <form ref="form" @submit.stop.prevent="saveService">
                    <div class="form-group mb-3" v-if="branch_id == 0">
                      <label>Select Branch</label>
                      <select                       
                        v-model="data.branch_id"
                        class="form-control"                      
                      >
                        <option value="All">All</option>
                        <option  v-for="item in GetBranch" :value="item.Id" :key="item.Id">{{item.branchName}}</option>
                      </select>
                      <div class="text-danger" v-if="branchError">
                        <em>{{ branchError }}</em>
                      </div>
                    </div>
                      <div class="mb-3">
                        <label class="col-form-label" for="service-name">Service Name:</label>
                        <input id="service-name" v-model="data.name" class="form-control" required type="text"
                               @keyup="checkName" placeholder="E.g Tooth Extraction">
                        <div class="text-danger" v-if="nameError">
                          <em>{{nameError}}</em>
                        </div>
                      </div>
                      <div class="mb-3">
                        <label class="col-form-label" for="service-cost">Service Cost:</label>
                        <input id="service-cost" @keyup="addComma" v-model="data.cost" class="form-control" required type="text" placeholder="E.g 4,000">
                        <div class="text-danger" v-if="costError">
                          <em>{{costError}}</em>
                        </div>
                        <div class="text-info">
                          <em>What it cost a facility to do this service (Buying price)</em>
                        </div>
                      </div>
                      <div class="mb-3">
                        <label class="col-form-label" for="service-price">Service Price:</label>
                        <input id="service-price" v-model="data.price" class="form-control" required
                               type="text" @keyup="addComma" placeholder="E.g 5,500">
                        <div class="text-danger" v-if="priceError">
                          <em>{{priceError}}</em>
                        </div>
                        <div class="text-info">
                          <em>What clients pay for this service (Selling price)</em>
                        </div>
                      </div>
                    </form>
                    <div class="modal-footer">
                      <button class="btn btn-secondary"  @click="$bvModal.hide('dental-modal')" type="button">Close</button>
                      <button v-if="existingServices.length" class="btn btn-info" disabled title="This Service already exists"
                              type="button"><i class="fa fa-ban"></i> Save Service
                      </button>
                      <button v-else class="btn btn-primary" type="button" @click="handleAddModal">Save Service</button>
                    </div>
                  </b-modal>

                  <!--EDITING SERVICE MODAL-->
                  <b-modal id="edit-modal" centered ref="modal" hide-footer :title="editData.name"
                           @hidden="resetEditModal">
                    <form ref="form" @submit.stop.prevent="saveChanges">
                    <div class="form-group mb-3" v-if="branch_id == 0">
                      <label>Select Branch</label>
                      <select                       
                        v-model="editData.branch_id"
                        class="form-control"                      
                      >
                        <option value="All">All</option>
                        <option  v-for="item in GetBranch" :value="item.Id" :key="item.Id">{{item.branchName}}</option>
                      </select>
                      <div class="text-danger" v-if="branchError">
                        <em>{{ branchError }}</em>
                      </div>
                    </div>
                      <div class="mb-3">
                        <label class="col-form-label" for="name">Service Name:</label>
                        <input id="name" v-model="editData.name" @keyup="checkName" class="form-control" type="text">
                        <div class="text-danger" v-if="nameError">
                          <em>{{nameError}}</em>
                        </div>
                      </div>
                      <div class="mb-3">
                        <label class="col-form-label" for="cost">Service Cost:</label>
                        <input id="cost" @keyup="addComma" v-model="editData.cost" class="form-control" type="text">
                        <div class="text-danger" v-if="costError">
                          <em>{{costError}}</em>
                        </div>
                        <div class="text-info">
                          <em>What it cost a facility to do this service (Buying price)</em>
                        </div>
                      </div>
                      <div class="mb-3">
                        <label class="col-form-label" for="price">Service Price:</label>
                        <input id="price" v-model="editData.price" class="form-control" type="text" @keyup="addComma" >
                        <div class="text-danger" v-if="priceError">
                          <em>{{priceError}}</em>
                        </div>
                        <div class="text-info">
                          <em>What clients pay for this service (Selling price)</em>
                        </div>
                      </div>
                    </form>
                    <div class="modal-footer">
                      <button class="btn btn-secondary" @click="$bvModal.hide('edit-modal')" type="button">Close</button>
                      <button v-if="existingServices.length" class="btn btn-info" disabled title="This Service already exists"
                              type="button"><i class="fa fa-ban"></i> Save Service
                      </button>
                      <button v-else class="btn btn-primary" type="button" @click="handleEditModal">Save Service</button>
                    </div>
                  </b-modal>

                  <!--                  DELETING SERVICE MODAL-->
                  <b-modal
                      id="delete-modal" header-bg-variant="warning" header-text-variant="light"
                      ref="modal" size="sm" centered
                      title="Confirmation Alert"
                      @hidden="resetDeleteModal"
                      @ok="confirmDelete"
                  >
                    <div class="d-block text-center">
                      <h5>
                        Are you sure you want to delete <code>{{this.deleteData.name}}</code>? <br>
                        Click <code>OK</code> to continue
                      </h5>
                    </div>
                  </b-modal>

                </div>
              </div>
            </div>
            <!-- Table -->
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        v-model="perPage"
                        :options="pageOptions"
                        class="form-select form-select-sm"
                        size="sm"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>

              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        class="form-control form-control-sm ms-2"
                        placeholder="Search..."
                        type="search"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  :current-page="currentPage"
                  :fields="fields"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  :items="this.dentalServices"
                  :per-page="perPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  bordered
                  class="datatables"
                  responsive="sm"
                  @filtered="onFiltered">
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(action)="data">
                  <!-- Edit Modal -->
                  <b-button v-if="user_permissions.edit_dental"
                      v-b-modal.edit-modal
                      size="sm"
                      variant="primary"
                      @click="showEditModal(data)"><i class="fa fa-edit"></i> Edit
                  </b-button>
                  <b-button v-else
                  disabled
                      v-b-modal.edit-modal
                      size="sm"
                      variant="primary"
                      @click="showEditModal(data)"><i class="fa fa-edit"></i> Edit
                  </b-button>
                  |
                  <!-- Delete Modal -->
                  <b-button v-if="user_permissions.delete_dental"
                      v-b-modal.delete-modal
                      size="sm"
                      variant="danger"
                      @click="showDeleteModal(data)"
                  ><i class="fa fa-trash"></i> Delete
                  </b-button
                  >
                  <b-button v-else
                  disabled
                      v-b-modal.delete-modal
                      size="sm"
                      variant="danger"
                      @click="showDeleteModal(data)"
                  ><i class="fa fa-trash"></i> Delete
                  </b-button
                  >
                </template>
              </b-table>
              <h3 v-if="!this.dentalServices" class="text-primary text-center">
                <b-spinner
                    class="m-0"
                    role="status"
                    variant="primary"
                ></b-spinner>
                Please wait...
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
// import { ModelListSelect } from "vue-search-select";
import {mapGetters, mapActions} from "vuex";

export default {
  page: {
    title: "Other Services Section",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  components: {
    Layout,
    PageHeader,
    // ModelListSelect
  },

  data() {
    return {
      title: "Dental Services",
      items: [
        {
          text: "Other Service Section",
          href: "#",
        },
        {
          text: "Dental Services",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 15,
      pageOptions: [15, 25, 50, 100, 250, 500, 1000],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: true,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "branch.name",
          sortable: true,
          label: "BRANCH",
        },
        {
          key: "serviceName",
          sortable: true,
          label: "SERVICE NAME",
        },
        {
          key: "serviceCost",
          sortable: true,
          label: "COST",
        },
        {
          key: "servicePrice",
          sortable: true,
          label: "PRICE",
        },
        {
          key: "dateCreated",
          sortable: true,
          label: "DATE & TIME",
        },
        {
          key: "action",
          sortable: false,
          label: "ACTION",
        },
      ],
      data: {
        name: "",
        branch_id: "All",
        type: "6",
        cost: "",
        price: "",
      },
      existingServices: [],
      nameError: "",
      priceError: "",
      costError: "",
      branchError:"",
      editData: {
        id: "",
        name: "",
        cost: "",
        price: "",
        branch_id: "",
      },
      deleteData:{
        id: "",
        name: "",
      }
    };
  },

  computed: {
    ...mapGetters("services", ["dentalServices"]),
    ...mapGetters("auth", ["user_permissions","branch_id"]),
    ...mapGetters("branch", ["GetBranch"]),

    rows() {
      return this.dentalServices ? this.dentalServices.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.dentalServices ? this.dentalServices.length : 1;
  },
  methods: {
    ...mapActions({
      FetchDentals: "services/fetchDentalServices",
      SubmitService: "services/saveService",
      SubmitUpdates: "services/updateService",
      DeleteService: "services/deleteService",
      FetchBranch: "branch/fetchBranch",
    }),

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering Separator
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    thousandSeparator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    checkName() {
      //when creating a new one
      if (this.data.name != "") {
        this.existingServices = this.dentalServices.filter((service) => {
          return service.serviceName.toUpperCase() == this.data.name.toUpperCase();
        });
        if (this.existingServices.length){
          this.nameError = this.data.name+" exists already";
        }else{
          this.nameError =""
        }
      } else {
        this.existingServices = [];
      }

    },

    addComma() {
      this.priceError="";
      this.costError="";
      //========================
      this.data.price = this.thousandSeparator(this.data.price);
      this.data.cost = this.thousandSeparator(this.data.cost);
      //========================
      this.editData.cost = this.thousandSeparator(this.editData.cost);
      this.editData.price = this.thousandSeparator(this.editData.price);
    },

    handleAddModal(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.saveService()
    },

    saveService() {
      //Now validate for required fields
      if (this.data.name==""){
        this.nameError="Service name is required";
        return;
      }else {
        this.nameError=""
      }
      if (this.data.cost==""){
        this.costError="Service cost is required";
        return;
      }else {
        this.costError=""
      }
      if (this.data.price==""){
        this.priceError="Service price is required";
        return;
      }else {
        this.priceError=""
      }
      if (this.data.branch_id==""){
        this.branchError="Branch field is required";
        return;
      }else {
        this.branchError=""
      }

      // Push the data submitted to the endpoint
      this.SubmitService(this.data);

      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('dental-modal')
      })
    },

    //Now reset the add modal
    resetAddModal() {
      this.data.name = "";
      this.data.cost = "";
      this.data.price = "";
      this.data.branch_id = "All",
      this.nameError = "";
      this.priceError = "";
      this.costError = "";
      this.existingServices = [];
    },

    showEditModal(data) {
      this.editData.id=data.item.id;
      this.editData.branch_id=data.item.branch_id;
      this.editData.name=data.item.serviceName;
      this.editData.cost=data.item.serviceCost;
      this.editData.price=data.item.servicePrice;
    },

    handleEditModal(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.saveChanges()
    },

    saveChanges() {
      //Now validate for required fields
      if (this.editData.name==""){
        this.nameError="Service name is required";
        return;
      }else {
        this.nameError=""
      }
      if (this.editData.cost==""){
        this.costError="Service cost is required";
        return;
      }else {
        this.costError=""
      }
      if (this.editData.price==""){
        this.priceError="Service price is required";
        return;
      }else {
        this.priceError=""
      }
      if (this.editData.branch_id==""){
        this.branchError="Branch field is required";
        return;
      }else {
        this.branchError=""
      }

      // Push the data submitted to the endpoint
      this.SubmitUpdates(this.editData);

      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('edit-modal')
      })
    },

    resetEditModal(){
      this.editData.name = "";
      this.editData.cost = "";
      this.editData.price = "";
      this.editData.branch_id = "";
      this.nameError = "";
      this.priceError = "";
      this.costError = "";
      this.branchError = "";
      this.editData.id="";
    },
    showDeleteModal(data) {
      this.deleteData.name=data.item.serviceName;
      this.deleteData.id=data.item.id;
    },
    confirmDelete(){
      // Push the data submitted to the endpoint
      this.DeleteService(this.deleteData);

      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('delete-modal')
      })
    },
    resetDeleteModal(){
      this.deleteData.id="";
      this.deleteData.name="";
    },


  },

  created() {
    this.FetchDentals();
    this.FetchBranch();
  },
};
</script>

<style lang="css" scoped>
</style>